var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"overviewMap",staticClass:"main"},[_c('div',{staticClass:"device-container"},[_c('div',{ref:"myMap",staticStyle:{"width":"calc(100vw)"},style:({'min-height':_vm.indoorType==='list'?'27vh':'calc(100vh - 105px)','height':_vm.indoorType==='list'?'27vh':'calc(100vh - 105px)'}),attrs:{"id":"myMap"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }